module.exports = __webpack_public_path__ + "static/media/tag_keyi.346fb053.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/tag_keyi.svg
// module id = 771
// module chunks = 0